<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Base Location"
      text="Update base location"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localCityState.stateId"
                v-validate="'required'"
                :error-messages="errors.collect('stateId')"    
                data-vv-name="stateId"
                data-vv-as="state"
                :items="states"
                label="State"
                item-text="name"
                item-value="id"
                hide-selected
                hide-no-data
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localCityState.cityId"
                v-validate="'required'"
                :error-messages="errors.collect('cityId')"    
                data-vv-name="cityId"
                data-vv-as="city"
                label="City"
                :items="filteredCities"
                item-text="name"
                item-value="id" 
                hide-selected
                hide-no-data
                outlined
              />
            </v-col> 
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      city: {
        type: Object,
        required: true,
      },
      state: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        states: [],
        cities: [],
        loading: false, 
        localCityState: null,
      }
    },
    computed: {
      filteredCities () {
        return this.cities.filter(city => {
          return city.state_id === this.localCityState.stateId
        })
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loading = true

        this.localCityState = { stateId: this.state.id, cityId: this.city.id }

        Promise.all([
          this.$api.hrisCities().list(),
          this.$api.hrisStates().list(),
        ])
          .then(([city, state]) => {
            this.cities = city.data
            this.states = state.data

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            Promise.all([
              this.$api.jobDetails().update(this.employeeUid, this.prepareFormData()),
              this.$api.hrisEmployeeCities().create(this.employeeUid, this.prepareFormData()),
            ])
              .then(([employee, employeeCities]) => {
                if (employee.status === 200 && employeeCities.status === 201) {
                  this.$emit('updated')
                  this.$snack({ message: 'Employee base location updated' })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          city_id: this.localCityState.cityId,
        }
      },
    },
  }
</script>
